"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  var domElem = document.querySelector("link[rel='canonical']");
  var existingValue = domElem.getAttribute("href");
  var baseProtocol = domElem.getAttribute("data-baseProtocol");
  var baseHost = domElem.getAttribute("data-baseHost");
  if (existingValue && baseProtocol && baseHost) {
    domElem.setAttribute("href", baseProtocol + "//" + baseHost + location.pathname + location.search + location.hash);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-canonical-urls/gatsby-browser.js
// module id = 612
// module chunks = 231608221292675